import {
	AuMeasurementStatuses,
	SensorStatusesDescription,
	SystemRunStatuses,
	AuMeasurementStatusesTranslationKeys,
} from './au-enums';

export const PredictiveMaintenanceFilterOptions = [
	{
		id: AuMeasurementStatuses.NORMAL,
		name: AuMeasurementStatuses.NORMAL,
	},
	{
		id: AuMeasurementStatuses.WARNING,
		name: AuMeasurementStatuses.WARNING,
	},
	{
		id: AuMeasurementStatuses.CRITICAL,
		name: AuMeasurementStatuses.CRITICAL,
	},
	{
		id: AuMeasurementStatuses.NoData,
		name: 'No Data',
	},
];

export const ComfortStatusFilterOptions = [
	{
		id: AuMeasurementStatuses.GOOD,
		name: AuMeasurementStatuses.GOOD,
	},
	{
		id: AuMeasurementStatuses.OK,
		name: AuMeasurementStatuses.OK,
	},
	{
		id: AuMeasurementStatuses.POOR,
		name: AuMeasurementStatuses.POOR,
	},
];

export const BuildingKpiStatusFilterOptions = [
	{
		id: AuMeasurementStatuses.GOOD,
		name: AuMeasurementStatusesTranslationKeys[AuMeasurementStatuses.GOOD],
	},
	{
		id: AuMeasurementStatuses.OK,
		name: AuMeasurementStatusesTranslationKeys[AuMeasurementStatuses.OK],
	},
	{
		id: AuMeasurementStatuses.POOR,
		name: AuMeasurementStatusesTranslationKeys[AuMeasurementStatuses.POOR],
	},
	{
		id: AuMeasurementStatuses.NORMAL,
		name: AuMeasurementStatusesTranslationKeys[AuMeasurementStatuses.NORMAL],
	},
	{
		id: AuMeasurementStatuses.WARNING,
		name: AuMeasurementStatusesTranslationKeys[AuMeasurementStatuses.WARNING],
	},
	{
		id: AuMeasurementStatuses.CRITICAL,
		name: AuMeasurementStatusesTranslationKeys[AuMeasurementStatuses.CRITICAL],
	},
];

export const SystemRunOptions = [
	{
		id: SystemRunStatuses.any,
		name: SensorStatusesDescription.any,
	},
	{
		id: SystemRunStatuses.running,
		name: SensorStatusesDescription.running,
	},
	{
		id: SystemRunStatuses.notRunning,
		name: SensorStatusesDescription.notRunning,
	},
	{
		id: SystemRunStatuses.analyzing,
		name: SensorStatusesDescription.analyzing,
	},
	{
		id: SystemRunStatuses.noStatus,
		name: SensorStatusesDescription.noStatus,
	},
];
